<template>
  <div class="card-tags-wrapper">
    <CardTagsViewPopup
      v-if="mode === Mode.View"
      ref="viewRef"
      :card-id="cardId"
      @showEditTagPopup="setMode(Mode.Edit)"
      @closePopup="handleClose"
      @esc="handleEsc"
      @tagSelected="handleTagSelected"
      @singleTagSelected="handleSingleTagSelected"
    />
    <CardTagsEditPopup
      v-else-if="mode === Mode.Edit"
      ref="editRef"
      :card-id="cardId"
      @showViewTagPopup="setMode(Mode.View)"
      @closePopup="handleClose"
      @esc="handleEsc"
    />
  </div>
</template>

<script lang="ts">
// `defineProps()` in `<script setup>` is hoisted, so use a separate `<script>` for module scope initializations
enum Mode {
  View = 'view',
  Edit = 'edit',
}
</script>

<script setup lang="ts">
import { ref, Ref, onMounted } from 'vue';
import CardTagsEditPopup from './CardTagsEditPopup.vue';
import CardTagsViewPopup from './CardTagsViewPopup.vue';

const viewRef: any = ref(null);
const editRef: any = ref(null);
const mode: Ref<Mode> = ref(Mode.View);

defineProps({
  initMode: {
    type: String,
    required: false,
    default: Mode.View,
  },
  cardId: {
    type: String,
    required: true,
  },
});

const setMode = (val: Mode) => {
  mode.value = val;
};

const focusInput = () => {
  if (mode.value === Mode.Edit) {
    editRef.value?.focusInput();
  } else {
    viewRef.value?.focusInput();
  }
};

const handleShow = () => {
  focusInput();
};

const handleEsc = () => {
  emit('esc');
};

const handleClose = () => {
  emit('close-tippy');
};

const handleTagSelected = (tag: any) => {
  emit('tagSelected', tag);
};

const handleSingleTagSelected = (tag: any) => {
  emit('singleTagSelected', tag);
};

const emit = defineEmits(['close-tippy', 'esc', 'tagSelected', 'singleTagSelected']);

onMounted(() => {
  const focusTimeout = setTimeout(() => {
    focusInput();
    clearTimeout(focusTimeout);
  }, 0);
});

defineExpose({
  focusInput,
  handleShow,
});
</script>
